module.exports = __webpack_public_path__ + "img/2-2.8aced21b.svg";